
import { useUI } from "providers/UIProvider"
import { useNavigate } from "react-router-dom"

import { settingsConfig } from "./settingsConfig"

import { ISettingItem } from "./SettingsCardsTypes"

import { Container, Flex } from "@chakra-ui/react"
import DashboardCard from "components/UI/organisms/DashboardCard"

const SettingsCards = () => {
  const navigate = useNavigate()

  const { T } = useUI()

  const settingsList = settingsConfig(T)

  return (
    <Container maxW="100%" mt="200px" mr="0" ml="0">
      <Flex w="100%" flexWrap="wrap" gap="30px" justifyContent="center">
        {settingsList.map((settingItem: ISettingItem) => (
          <DashboardCard
            key={settingItem.id}
            title={settingItem.subTitle}
            icon={settingItem.icon}
            width="180px"
            height="180px"
            bg="white"
            boxshadow="0px 100px 50px #046CEC0D"
            borderRadius="30px"
            iconStyles={{
              fill: "#046CEC",
              width: "56px",
              height: "56px"
            }}
            onClick={()=>navigate(`${settingItem.url}`)}
            isPremium={settingItem.isPremium}
            headingSize="s"
          />
        ))}
      </Flex>
    </Container>
  )
}

export default SettingsCards